import styled from '@emotion/styled'

export const LauncherButton = styled.button`
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 1100;

  padding: 8px 12px;
  border: 0;
  border-radius: 18px;

  color: #fff;
  font-size: 12px;
  font-weight: 600;
  background: ${({ isLocal }) => (isLocal ? '#d46b08' : '#595959')};
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.22);
  cursor: pointer;
`

export const ServiceRow = styled.div`
  display: grid;
  grid-template-columns: 140px 70px minmax(220px, 1fr);
  gap: 12px;
  align-items: center;

  margin-bottom: 12px;
`

export const PanelSection = styled.section`
  margin-top: 24px;
`
